import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";
import { Site, WelcomeSection } from "../../../../model/site";
import { getThemeFromSite } from "../../../../model/theme";

const Frame = styled.div<{ $background: string; $color: string }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  overflow: hidden;
  background: ${props => props.$background};
  border-radius: 12px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);

  @media (min-width: ${DESKTOP_BREAKPOINT}) {
    width: 88px;
    height: 88px;
  }

  img {
    width: 60%;
    height: 60%;
    object-fit: cover;
    border-radius: 100%;
  }

  span {
    font-family: Poppins, sans-serif;
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 1;
    color: ${props => props.$color};
    text-transform: uppercase;
  }

  /* In a list's card: as a Keepo Link's icon */
  &.compact {
    width: 40px;
    height: 40px;

    @media (min-width: ${DESKTOP_BREAKPOINT}) {
      width: 56px;
      height: 56px;
    }

    img {
      width: 64%;
      height: 64%;
    }

    span {
      font-size: 1.25rem;
    }
  }
`;

type Props = {
  site: Site;
  /** Smaller, for a list's card (Meus Keepos), as a Keepo Link's icon. */
  compact?: boolean;
};

/** Square thumbnail of a Keepo: its welcome logo (or the title's initial) over the theme's main color. */
export const SiteThumbnail = ({ site, compact }: Props) => {
  const theme = getThemeFromSite(site);
  const welcome = site.sections?.find(section => section.type === "welcome") as WelcomeSection | undefined;
  const logo = welcome?.active !== false ? welcome?.logo : undefined;

  return (
    <Frame
      $background={theme.primary}
      $color={theme.secondary}
      className={compact ? "compact" : undefined}
      aria-hidden="true">
      {logo ? <img src={logo} alt="" loading="lazy" /> : <span>{site.title?.trim().charAt(0) || "K"}</span>}
    </Frame>
  );
};
